import React, { useMemo } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import * as PropTypes from 'prop-types';

import { ConnectionShape } from '../../../../redux/opentok/helpers/shapes';
import SubscriberBtns from '../SubscriberBtns';
import MemberView from '../MemberView';
import InviteeView from '../InviteeView';
import InviteeBtns from '../InviteeBtns';
import styles from './styles.styl';

function MemberList({
  publisher,
  subscribers,
  onSelect,
  pinnedId,
  isProvider,
  onPin,
  invitations,
}) {
  const members = useMemo(() => Object.entries(subscribers), [subscribers]);

  return (
    <div className={styles.root}>
      <TransitionGroup>
        {publisher && (
          <CSSTransition timeout={300} classNames="vv-member">
            <MemberView
              onClick={onSelect}
              connection={publisher}
              showControls
            />
          </CSSTransition>
        )}
        {members.map(([id, connection]) => (
          <CSSTransition key={id} timeout={300} classNames="vv-member">
            <MemberView
              showControls={!isProvider}
              connection={connection}
              onClick={onSelect}
            >
              <SubscriberBtns
                pinnedId={pinnedId}
                connection={connection}
                isProvider={isProvider}
                onPin={onPin}
              />
            </MemberView>
          </CSSTransition>
        ))}
        {invitations.map(invitee => (
          <CSSTransition
            key={invitee.login}
            timeout={300}
            classNames="vv-member"
          >
            <InviteeView invitee={invitee}>
              <InviteeBtns invitee={invitee} isProvider={isProvider} />
            </InviteeView>
          </CSSTransition>
        ))}
      </TransitionGroup>
    </div>
  );
}

MemberList.propTypes = {
  publisher: ConnectionShape,
  subscribers: PropTypes.shape({ id: ConnectionShape }),
  onSelect: PropTypes.func,
  pinnedId: PropTypes.string,
  onPin: PropTypes.func,
  isProvider: PropTypes.bool,
  invitations: PropTypes.array,
};

export default MemberList;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/MemberList/index.jsx